import React, { PureComponent } from 'react';
import { Col, Row } from 'react-grid-system';

import { I18n } from 'components/translate';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import EngagementModal from './EngagementModal';

import './BigNumberCard.scss';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
class BigNumberCard extends PureComponent {
  static propTypes = {
    renderRightColumn: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string,
    isMobile: PropTypes.bool
  };

  state = {
    showEngagementInfo: false
  };

  openEngagement = () => this.setState({ showEngagementInfo: true });

  closeEngagement = () => this.setState({ showEngagementInfo: false });

  render() {
    const { renderRightColumn, title, value, description, isMobile } =
      this.props;
    const { showEngagementInfo } = this.state;
    const shouldRenderRightColumn = renderRightColumn && !isMobile;

    return (
      <Row nogutter className="big-numbers__card">
        <Col
          md={
            shouldRenderRightColumn
              ? // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                9
              : // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                12
          }
        >
          <h3 className="big-numbers__card__title">{title}</h3>
          <strong className="big-numbers__card__data">{value}</strong>
          <span className="big-numbers__card__description">{description}</span>
        </Col>
        {shouldRenderRightColumn && (
          <Col md={3}>
            {renderRightColumn()}
            <div
              onClick={this.openEngagement}
              className="big-numbers__card__view-more"
            >
              <I18n label="general.view_more" />
            </div>
          </Col>
        )}
        {showEngagementInfo && (
          <EngagementModal onClose={this.closeEngagement} />
        )}
      </Row>
    );
  }
}

export default BigNumberCard;
